import { render } from "./ComprasRecibir.vue?vue&type=template&id=e991dd8a&scoped=true"
import script from "./ComprasRecibir.vue?vue&type=script&lang=js"
export * from "./ComprasRecibir.vue?vue&type=script&lang=js"

import "./ComprasRecibir.vue?vue&type=style&index=0&id=e991dd8a&lang=scss&scoped=true"

import exportComponent from "C:\\laragon\\www\\framacion_front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e991dd8a"]])

export default __exports__